import React, { useState, useRef, useEffect } from 'react';
//import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import { withTranslation } from 'react-i18next';
import { postDataFetcher } from '../../dataFetcher';
import CONFIG_OBJECT from '../../config/config';
import { isMobile } from 'react-device-detect';
import EyeColors from './EyeColors';
import ResultBlk from './ResultBlk';
import Loader from './Loader/Loader';
import EyeColorLandingForm from './EyeColor-landing-form/EyeColorLandingForm';
import './EyeColorPredictorData.css';
import './EyeColorPredictor.css';
import App_Constants from '../../app-constants/App_Constants';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

// General scroll to element function
const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

const apidata = {
  motherColorId: '',
  motherColorName: '',
  fatherColorId: '',
  fatherColorName : ''
}

const EyeColorPredictor = (props) => {

  //Declare state variables
  const [eyeColor, setEyeColor] = useState({
    motherColorName: '',
    fatherColorName : ''
  })
  const [showDesc, setShowDesc] = useState(isMobile ? false : true);
  const [showForm, setShowForm] = useState(true);
  const [showEditForm, setShowEditForm] = useState(false);
  const [componentData, setComponentData] = useState({})
  const [btnEnable, setBtnEnable] = useState({
    mData: {
      state: false,
      id: ''
    },
    fData: {
      state: false,
      id: ''
    }
  })
  const [responseData, setResponseData] = useState({
    data: {
      graphData: [],
      mostProbableColorData: []
    }
  })
  const [resultBlk, setResultBlk] = useState({
    data: {
      rBlk: false,
      activeObject: null,
      loader: false
    }
  })
  const [btnEdit, setBtnEdit] = useState(true)
  const resultRef = useRef(null)
  const executeScroll = () => scrollToRef(resultRef)

  const showMainMenu = () => {
    setShowForm(true);
    setShowEditForm(false)
    setTimeout(function () { window.scrollTo(0, 0); }, 0);
    // setDisableBtn(true);
  }
  //Update the Mother Handler State
  const eventMHandler = (fetchData) => {
    setBtnEnable({
      ...btnEnable,
      mData: {
        state: fetchData !== null ? true : false,
        id: fetchData !== null ? fetchData.id : ''
      }
    })
  }

  //Update the Father Handler State
  const eventFHandler = (fetchData) => {
    setBtnEnable({
      ...btnEnable,
      fData: {
        state: fetchData !== null ? true : false,
        id: fetchData !== null ? fetchData.id : ''
      }
    })
  }

  //Hooks to get the layout service to build the component layout
  useEffect(() => {
    if (sessionStorage.getItem('ECPLSComponentData')) {
      //Captured in session storage 
      setComponentData(JSON.parse(sessionStorage.getItem('ECPLSComponentData')));
    } else {
      //bind the component data from props and store in the session for caching purpose
      let componentData = props.fields
      sessionStorage.setItem('ECPLSComponentData', JSON.stringify(componentData));
      setComponentData(componentData);
    }
  }, [])

  //Hook to update the state based on the btnEnable state
  // useEffect(() => {
  //   if (!btnEnable.mData.state || !btnEnable.fData.state) {
  //     setBtnEdit(true)
  //   } else {
  //     setBtnEdit(false)
  //   }
  // }, [btnEnable])

  //Async function to update the ResultBlk state
  const loading = async (data) => {
    setResultBlk({
      ...resultBlk,
      data: {
        rBlk: false,
        activeObject: null,
        loader: true
      }
    })

    const initialData = {
      eyeColor: apidata.motherColorId,
      partnerEyeColor: apidata.fatherColorId
    }

    //Rest API call to get the response
    return (
      postDataFetcher(`${CONFIG_OBJECT.ECP_REST_URL}${App_Constants.SC_API_KEY}`, initialData)
        .then(res => {
          Promise.resolve()
            .then(() => {
              setResponseData({
                ...responseData,
                data: {
                  graphData: res.data.Data.mostProbableColorList.length > 1 ? res.data.Data.colorPercentageList.reverse() : res.data.Data.colorPercentageList,
                  mostProbableColorData: res.data.Data.mostProbableColorList
                }
              })
              setBtnEdit(true)
              setResultBlk({
                ...resultBlk,
                data: {
                  rBlk: true,
                  activeObject: '',
                  loader: false
                }
              })
              executeScroll()
            })
        })
        .catch(err => {
          if (err.response) {
            // client received an error response (5xx, 4xx)
            console.log('Response error: ', err.response)
          } else if (err.request) {
            // client never received a response, or request never left
            console.log('Request error: ', err.request)
          } else {
            // anything else
            console.log(err)
          }
        })
    )
  }

  const { t } = props;

  const predictEyeColor = (e) => {
    if (isMobile) {
      setShowDesc(false)
      setShowForm(false)
      setShowEditForm(true)
    }
    loading(btnEnable)
  }

  const sendMotherColor = (motherItem) => {
    // console.log(motherItem)
    apidata.motherColorId = motherItem.id
    apidata.motherColorName = motherItem.fields.colorName.value
    setEyeColor({
      motherColorName : apidata.motherColorName,
      fatherColorName : apidata.fatherColorName
    })
    if (apidata.fatherColorId !== '') {
      setBtnEdit(false)
    }
  }

  const sendFatherColor = (fatherItem) => {
    // console.log(fatherItem)
    apidata.fatherColorId = fatherItem.id
    apidata.fatherColorName = fatherItem.fields.colorName.value
    setEyeColor({
      motherColorName : apidata.motherColorName,
      fatherColorName : apidata.fatherColorName
    })
    if (apidata.motherColorId !== '') {
      setBtnEdit(false)
    }
  }

  // Rendering Component

  return (
    <>{componentData.description &&
      <section className="" id="main">
        <div className="eye-color-predictor">
          <div className="calculator-body">
            {showDesc &&
              <div className="container">
                <p className="ovulation-intro">{componentData.description.value}</p>
              </div>
            }
            {showEditForm &&
              <div className="goals-section container-mobile">
                <div className="recalculate-wrap-period-form">
                  <div className="container">
                    <div className="fdlp-mobile">
                      <span>{componentData.eyeColorLabel.value}</span><span style={{ 'textTransform': 'capitalize' }}>{apidata.motherColorName}</span>
                    </div>
                    <div className="cycle-length-mobile">
                      <span>{componentData.partnerEyeColorLabel.value}</span><span>{apidata.fatherColorName}</span>
                    </div>

                    <button onClick={showMainMenu}>
                      <img src="https://dev1.v2.wemshowcase.com/-/media/JssReactWeb/data/media/img/Common/red_pencil.ashx?h=15&amp;w=15&amp;hash=CA6D8D1AE479F86ACEBAF8CBC007C43D" />
                      <span>Edit</span>
                    </button>
                  </div>
                </div>
              </div>
            }
            {showForm &&
              <div>
                <div className="container">
                  <div className="form-container form-container-eyecolor">
                    <form className="form" onSubmit={(e) => { e.preventDefault() }}>
                      <div className="inputform landing-form">
                        <div className="eye-landing-form-field-wrapper">

                          <EyeColorLandingForm componentData={componentData} sendMotherColor={sendMotherColor} sendFatherColor={sendFatherColor} eyeColor={eyeColor}/>

                        </div>
                        <div className='blk blk-btn'>
                          <input
                            type="submit"
                            id="name-search-button"
                            className="btn btn-p"
                            value={t('EyeColorPredictor_PredictButton')}
                            disabled={btnEdit}
                            onClick={() => predictEyeColor(this)}
                          />
                        </div>
                      </div>
                      {/* <div className="inputform">
                          <div className="form-group">
                            <label>{componentData.eyeColorLabel.value}</label>
                            <EyeColors                    
                              onFetchData = {eventFHandler.bind(this)}
                              colors={componentData.eyeColorList}                      
                              activeObject={resultBlk.data.activeObject}
                            />                    
                          </div>
                          <div className="form-group">
                            <label>{componentData.partnerEyeColorLabel.value}</label>
                            <EyeColors 
                              onFetchData = {eventMHandler.bind(this)}
                              colors={componentData.eyeColorList}
                              activeObject={resultBlk.data.activeObject}
                            />                    
                          </div> 
                          <div className='blk blk-btn'>
                            <input 
                              type="submit" 
                              id="name-search-button" 
                              className="btn btn-p"
                              value={t('EyeColorPredictor_PredictButton')} 
                              disabled={btnEdit} 
                              onClick={() => predictEyeColor(this)}
                            />
                          </div>                                                     
                      </div> */}

                    </form>
                  </div>
                </div>
              </div>
            }
            {!isMobile &&
              <hr className="form-divider"></hr>
            }
            <div className="container">
              <div className="resultblk" ref={resultRef}>

                {
                  resultBlk.data.loader && <Loader />
                }
                {

                  resultBlk.data.rBlk &&
                  <div className="eye-predictor-social-share-component">
                    <div className="email-share-container">
                      <p className="share-email-text-msg">Share it with your family and friends!</p>
                      <Placeholder name="social-share-result" rendering={props.rendering} itemid={props.itemid} />
                    </div>
                  </div>
                }
                {

                  resultBlk.data.rBlk && (
                    <React.Fragment>
                      <ResultBlk
                        graphData={responseData.data.graphData}
                        mostProbableColorData={responseData.data.mostProbableColorData}
                      />
                      {/* <div className="disclaimer">{t('EyeColorPredictor_Disclaimer')}</div> */}
                    </React.Fragment>
                  )

                }

              </div>
            </div>
          </div>
          <div className="social-share-container">
            <div className="container">
              <Placeholder name="social-share" rendering={props.rendering} itemid={props.itemid} />
            </div>
          </div>
        </div>
        <div className="period-calculator-note-section">
          <p>
            {componentData.disclaimerMessage.value}
          </p>
        </div>
      </section>
    }
    </>)

}

export default withTranslation()(EyeColorPredictor)

